// GSAP
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/src/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );

// Timeline init
let our_care_tl = gsap.timeline( { defaults: { repeat: 0, duration: 0.5} } );

if( $('body').hasClass('who-we-are-page') ) {
    // Tween 1: Title fade-in up
    our_care_tl.from( 
        $('#our-care h2'), 
        {
            // scrollTrigger: {
            //     trigger: '#our-care',
            //     start: "0% 80%",
            //     end: "0% 50%",
            //     scrub: 2,
            // },
            y: 100,
            ease: 'back.out(1.1)'
        },
    );

    // Tween 2: Info text bounce from right
    our_care_tl.from( 
        $('#our-care .info-text'), 
        {
            // scrollTrigger: {
            //     trigger: '#our-care',
            //     start: "0% 80%",
            //     end: "0% 50%",
            //     scrub: 2,
            // },

            xPercent: 200,
            ease: 'back.out(1.1)'
        },
    );

    // Tween 2: Cards fade-in up
    our_care_tl.from( 
        $('#our-care .card'), 
        {
            // scrollTrigger: {
            //     trigger: '#our-care .card',
            //     start: "0% 100%",
            //     end: "80% 80%",
            //     scrub: 2,
            // },
            autoAlpha: 0,
            stagger: 0.1,
            y: 100,
            ease: 'back.out(1.2)',
        },
        
    );
}
        